import { render, staticRenderFns } from "./Erp6PurchaseOrderDelivery.vue?vue&type=template&id=2c00185e&scoped=true&"
import script from "./Erp6PurchaseOrderDelivery.vue?vue&type=script&lang=js&"
export * from "./Erp6PurchaseOrderDelivery.vue?vue&type=script&lang=js&"
import style0 from "./Erp6PurchaseOrderDelivery.vue?vue&type=style&index=0&id=2c00185e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00185e",
  null
  
)

export default component.exports